import { useEffect, useState } from 'react'
import s from './styles.module.scss'

interface titleOption {
    value: string
    label: string
}

interface InputFieldTitleSelectProps {
    fieldName: string
    saveValue: (obj: { field: string; value: string }) => { success: boolean; error: string }
    options: titleOption[]
    populateValue?: titleOption
    enhanced?: boolean
    required?: boolean
    showErrors?: boolean
    customStyles?: React.CSSProperties
}

export const InputFieldTitleSelect = (props: InputFieldTitleSelectProps) => {
    const {
        fieldName,
        saveValue,
        options,
        populateValue,
        enhanced = false,
        required = false,
        showErrors = false,
        customStyles,
    } = props

    const [selectedValue, setSelectedValue] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        if (populateValue) {
            setSelectedValue(populateValue.value)
        }
    }, [populateValue])

    useEffect(() => {
        if (showErrors && required && !selectedValue) {
            setError('This field is required')
        } else {
            setError('')
        }
    }, [showErrors, required, selectedValue])

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value
        setSelectedValue(newValue)

        const saveResult = saveValue({
            field: fieldName,
            value: newValue,
        })

        if (saveResult.success) {
            setError('')
        } else {
            setError(saveResult.error)
        }
    }

    return (
        <>
            <select
                className={`${s.titleSelect} ${enhanced ? s.enhanced : ''} ${error ? s.error : ''}`}
                style={customStyles}
                value={selectedValue}
                onChange={handleChange}
                required={required}
            >
                <option value="">Select Title</option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {error && <span className={s.notice}>{error}</span>}
        </>
    )
}
